import { Component, OnInit, Input } from '@angular/core';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service'
import { ValidationService } from '../../shared/providers/validation.service'

interface IBrokerage {
    BrokerageName: string;
    BrokerageURL: string
    SourceURL: string;
    PropertyBrokerageBrokersList: any[];
}

@Component({
    selector: 'app-property-brokerage',
    templateUrl: './property-brokerage.component.html'
})
export class PropertyBrokerageComponent implements OnInit {

    constructor(private BrokerageServie: BrokerageManagerService, private Validation: ValidationService) { }
    @Input() propertyId: number = 0;
    brokerage = {} as IBrokerage;
    dataExist = false;
    ngOnInit() {
        this.BrokerageServie.GetPropertyBrokerage(this.propertyId).subscribe(res => {
            if (res["BrokerageName"] !== null) {                
                this.brokerage.BrokerageName = res["BrokerageName"];
                this.brokerage.BrokerageURL = (res["BrokerageURL"] != null && res["BrokerageURL"] != '') ? this.Validation.formatURL(res["BrokerageURL"]) : null;
                this.brokerage.SourceURL = (res["SourceURL"] != null && res["SourceURL"] != '') ? this.Validation.formatURL(res["SourceURL"]) : null;
                this.brokerage.PropertyBrokerageBrokersList = [];
                this.brokerage.PropertyBrokerageBrokersList = res["PropertyBrokerageBrokersList"];
                this.dataExist = true;
            }
            else {
                this.dataExist = false;
            }
        });
    }
}
